<div class="d-flex flex-column h-100 placeholder-glow">
    
    <!-- page header -->
    <div class="my-1" style="border-bottom: 1px solid #eee;">
        <span class="my-2 placeholder col-12 placeholder" style="min-height: 2rem;"></span>
    </div>

    <div class="np-form-table my-1" *ngIf="filterRowCnt > 0">
        <div class="row" *ngFor="let i of counter(filterRowCnt)">
            <div class="td col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                <div class="cell-head"><label><span class="my-1 placeholder col-12"
                            style="width: 4rem;min-height: 1rem;"></span></label></div>
                <div class="cell-text">
                    <span class="my-1 placeholder col-12" style="min-height: 1rem;"></span>
                </div>
            </div>
            <div class="td col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                <div class="cell-head"><label><span class="my-1 placeholder col-12"
                            style="width: 4rem;min-height: 1rem;"></span></label></div>
                <div class="cell-text">
                    <span class="my-1 placeholder col-12" style="min-height: 1rem;"></span>
                </div>
            </div>
            <div class="td col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                <div class="cell-head"><label><span class="my-1 placeholder col-12"
                            style="width: 4rem;min-height: 1rem;"></span></label></div>
                <div class="cell-text">
                    <span class="my-1 placeholder col-12" style="min-height: 1rem;"></span>
                </div>
            </div>
            <div class="td col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                <div class="cell-head"><label><span class="my-1 placeholder col-12"
                            style="width: 4rem;min-height: 1rem;"></span></label></div>
                <div class="cell-text">
                    <span class="my-1 placeholder col-12" style="min-height: 1rem;"></span>
                </div>
            </div>
        </div>
    </div>

    <div class="h-100 rounded-1 d-flex flex-column" style="min-height: 1%;">

        <div class="text-end my-1">
            <button class="btn btn-primary btn-sm disabled placeholder me-1" style="width: 4rem;"></button>
            <button class="btn btn-secondary btn-sm disabled placeholder me-1" style="width: 4rem;"></button>
            <button class="btn btn-success btn-sm disabled placeholder me-1" style="width: 4rem;"></button>
            <button class="btn btn-warning btn-sm disabled placeholder me-1" style="width: 4rem;"></button>
            <button class="btn btn-danger btn-sm disabled placeholder me-1" style="width: 4rem;"></button>
        </div>

        <div class="d-flex flex-column h-100" style="min-height: 400px;background-color: #eeeeee;">
            <div class="p-3 my-1">
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
            </div>
        </div>

        <div class="my-1">
            <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
        </div>
    </div>

</div>